import { Navigate, type RouteObject } from 'react-router';
import { ConfigLayout } from '@/features/config/ConfigLayout';
import { ConfigHub } from '@/features/config/ConfigHub';
import { OrganizationPage } from '@/features/config/OrganizationPage';
import { EntityPage } from '@/features/config/EntityPage';
import { UsersPage } from '@/features/config/UsersPage';
import { SpecialtiesPage } from '@/features/config/SpecialtiesPage';
import { RolesPage } from '@/features/config/RolesPage';
import { CaseTypesPage } from '@/features/config/CaseTypesPage';
import { CourtsPage } from '@/features/config/CourtsPage';
import { TemplatesPage } from '@/features/config/TemplatesPage';
import { NotificationsPage, ChannelsPage, ArchiveSettingsPage } from '@/features/config/SettingsPages';
import { OutboundEmailPage } from '@/features/config/OutboundEmailCard';
import { DocumentStoragePage } from '@/features/config/DocumentStorageCard';
import { BackupStoragePage } from '@/features/config/BackupStoragePage';
import { AuditPage } from '@/features/config/AuditPage';
import { SlaPage } from '@/features/config/SlaPage';
import { DecisionEnginePage } from '@/features/config/DecisionEnginePage';
import { AssignmentPage } from '@/features/config/AssignmentPage';
import { FormsPage } from '@/features/config/FormsPage';
import { ActionsPage } from '@/features/config/ActionsPage';
import { WorkflowsListPage } from '@/features/workflows/WorkflowsListPage';
import { DesignerPage } from '@/features/workflows/designer/DesignerPage';
import { ReportsPage } from '@/features/reports/ReportsPage';
import { SetupPage } from '@/features/setup/SetupPage';

/** Administration area routes (configuration + reports). */
export const adminRoutes: RouteObject[] = [
  { path: 'reportes', element: <ReportsPage /> },
  // Puesta en marcha (en implementación) o estado de la configuración (en operación); incrusta pantallas de Configuración.
  { path: 'puesta-en-marcha', element: <SetupPage /> },
  // The designer takes the whole content area (no secondary nav).
  { path: 'configuracion/workflows/:id', element: <DesignerPage /> },
  {
    path: 'configuracion',
    element: <ConfigLayout />,
    children: [
      { index: true, element: <ConfigHub /> },
      { path: 'entidad', element: <EntityPage /> },
      { path: 'organigrama', element: <OrganizationPage /> },
      { path: 'organizacion', element: <Navigate to="../organigrama" replace /> },
      { path: 'usuarios', element: <UsersPage /> },
      { path: 'equipos', element: <Navigate to="../organigrama" replace /> }, // equipos viven ahora en el organigrama
      { path: 'especialidades', element: <SpecialtiesPage /> },
      { path: 'workflows', element: <WorkflowsListPage /> },
      { path: 'formularios', element: <FormsPage /> },
      { path: 'acciones', element: <ActionsPage /> },
      { path: 'sla', element: <SlaPage /> },
      { path: 'plantillas', element: <TemplatesPage /> },
      { path: 'canales', element: <ChannelsPage /> },
      { path: 'correo-saliente', element: <OutboundEmailPage /> },
      { path: 'almacenamiento', element: <DocumentStoragePage /> },
      { path: 'respaldo', element: <BackupStoragePage /> },
      { path: 'decision-engine', element: <DecisionEnginePage /> },
      { path: 'asignacion', element: <AssignmentPage /> },
      { path: 'notificaciones', element: <NotificationsPage /> },
      { path: 'expediente', element: <ArchiveSettingsPage /> },
      { path: 'permisos', element: <RolesPage /> },
      { path: 'tipos', element: <CaseTypesPage /> },
      { path: 'juzgados', element: <CourtsPage /> },
      { path: 'auditoria', element: <AuditPage /> },
      { path: '*', element: <ConfigHub /> },
    ],
  },
];
